import { useInvoiceCartStore } from '@/store';
import type { Invoice } from '@/types/invoice';

/**
 * Custom hook for Invoice Cart operations
 * Provides convenient methods for Invoice Cart actions
 */
export const useInvoiceCart = () => {
	// Destructure state and actions from auth store
	const {
		addInvoice,
		removeInvoice,
		clearCart,
		cartedInvoices,
		selectedInvoices,
	} = useInvoiceCartStore();

	const addInvoiceToCart = (invoice: Invoice) => {
		addInvoice(invoice);
	};
	const removeInvoiceFromCart = (id: string) => {
		removeInvoice(id);
	};

	const clearInvoicesFromCart = () => {
		clearCart();
	};

	return {
		addInvoiceToCart,
		removeInvoiceFromCart,
		clearInvoicesFromCart,
		selectedInvoices,
		cartedInvoices,
	};
};
